module.exports = __webpack_public_path__ + "static/img/logoReport.90d2f094.png";